class g {
  baseUrl;
  defaultHeaders;
  constructor(t, e = {}) {
    this.baseUrl = t, this.defaultHeaders = {
      "Content-Type": "application/json",
      ...e
    };
  }
  async request(t, e) {
    try {
      const r = new URL(`${this.baseUrl}${t}`);
      e.params && Object.entries(e.params).forEach(([n, i]) => {
        r.searchParams.append(n, i);
      });
      const o = await fetch(r.toString(), {
        method: e.method,
        headers: {
          ...this.defaultHeaders,
          ...e.headers
        },
        body: e.body ? JSON.stringify(e.body) : void 0,
        credentials: "include"
      });
      return o.ok ? await o.json() : null;
    } catch (r) {
      return console.error("Fetch request failed:", r), null;
    }
  }
  async post(t, e, r) {
    return this.request(t, {
      method: "POST",
      body: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async get(t, e, r) {
    return this.request(t, {
      method: "GET",
      params: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async put(t, e, r) {
    return this.request(t, {
      method: "PUT",
      body: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async delete(t, e) {
    return this.request(t, {
      method: "DELETE",
      headers: e?.headers,
      requiresAuth: e?.requiresAuth
    });
  }
}
class b {
  axiosInstance;
  constructor(t, e = {}) {
    let r;
    try {
      r = require("axios");
    } catch {
      throw console.error("Axios is not installed. Please install it using: npm install axios"), new Error("Axios is not installed");
    }
    this.axiosInstance = r.create({
      baseURL: t,
      headers: {
        "Content-Type": "application/json",
        ...e
      },
      withCredentials: !0
    });
  }
  async request(t, e) {
    try {
      return (await this.axiosInstance({
        url: t,
        method: e.method,
        headers: e.headers,
        data: e.body,
        params: e.params
      })).data;
    } catch (r) {
      return console.error("Axios request failed:", r), null;
    }
  }
  async post(t, e, r) {
    return this.request(t, {
      method: "POST",
      body: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async get(t, e, r) {
    return this.request(t, {
      method: "GET",
      params: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async put(t, e, r) {
    return this.request(t, {
      method: "PUT",
      body: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async delete(t, e) {
    return this.request(t, {
      method: "DELETE",
      headers: e?.headers,
      requiresAuth: e?.requiresAuth
    });
  }
}
class T {
  baseUrl;
  defaultHeaders;
  constructor(t, e = {}) {
    this.baseUrl = t, this.defaultHeaders = {
      "Content-Type": "application/json",
      ...e
    };
  }
  async request(t, e) {
    return new Promise((r) => {
      let o = `${this.baseUrl}${t}`;
      if (e.params) {
        const n = new URLSearchParams();
        Object.entries(e.params).forEach(([i, a]) => {
          n.append(i, a);
        }), o += `?${n.toString()}`;
      }
      uni.request({
        url: o,
        method: e.method,
        header: {
          ...this.defaultHeaders,
          ...e.headers
        },
        data: e.body,
        dataType: "json",
        success: (n) => {
          n.statusCode === 200 ? r(n.data) : r(null);
        },
        fail: (n) => {
          console.error("Uniapp request failed:", n), r(null);
        }
      });
    });
  }
  async post(t, e, r) {
    return this.request(t, {
      method: "POST",
      body: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async get(t, e, r) {
    return this.request(t, {
      method: "GET",
      params: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async put(t, e, r) {
    return this.request(t, {
      method: "PUT",
      body: e,
      headers: r?.headers,
      requiresAuth: r?.requiresAuth
    });
  }
  async delete(t, e) {
    return this.request(t, {
      method: "DELETE",
      headers: e?.headers,
      requiresAuth: e?.requiresAuth
    });
  }
}
class _ {
  static create(t, e, r = {}) {
    switch (t) {
      case "axios":
        return new b(e, r);
      case "uniapp":
        return new T(e, r);
      default:
        return new g(e, r);
    }
  }
  // 自动检测环境并选择适配器
  static createAutoDetect(t, e = {}) {
    if (typeof global < "u" && global.uni?.request)
      return new T(t, e);
    if (typeof window < "u" && window.fetch)
      return new g(t, e);
    if (typeof require < "u")
      try {
        return require.resolve("axios"), new b(t, e);
      } catch {
        console.warn("Axios not found, falling back to FetchAdapter");
      }
    return new g(t, e);
  }
}
class P {
  adapter;
  baseUrl;
  constructor(t) {
    this.baseUrl = t.baseUrl, t.autoDetect ? this.adapter = _.createAutoDetect(t.baseUrl, t.headers || {}) : this.adapter = _.create(
      t.adapterType || "fetch",
      t.baseUrl,
      t.headers || {}
    );
  }
  async request(t, e) {
    return this.adapter.request(t, e);
  }
  async post(t, e, r) {
    return this.adapter.post(t, e, r);
  }
  async get(t, e, r) {
    return this.adapter.get(t, e, r);
  }
  async put(t, e, r) {
    return this.adapter.put(t, e, r);
  }
  async delete(t, e) {
    return this.adapter.delete(t, e);
  }
}
let d = null;
const B = (s) => (d = new P(s), d);
class q {
  config;
  constructor(t = {}) {
    this.config = {
      baseURL: "",
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 3e4,
      ...t
    };
  }
  async request(t) {
    const { url: e, method: r = "GET", headers: o, params: n, data: i, ...a } = t, u = this.config.baseURL ? `${this.config.baseURL}${e}` : e, c = new URL(u);
    n && Object.entries(n).forEach(([p, h]) => {
      c.searchParams.append(p, h);
    });
    const f = {
      ...this.config.headers,
      ...o
    }, m = {
      method: r,
      headers: f,
      credentials: "include",
      ...a
    };
    i && ["POST", "PUT", "PATCH"].includes(r.toUpperCase()) && (m.body = JSON.stringify(i));
    const l = await fetch(c.toString(), m);
    if (!l.ok)
      throw new Error(`HTTP error! status: ${l.status}`);
    return await l.json();
  }
  get(t, e) {
    return this.request({
      url: t,
      method: "GET",
      ...e
    });
  }
  post(t, e, r) {
    return this.request({
      url: t,
      method: "POST",
      data: e,
      ...r
    });
  }
  put(t, e, r) {
    return this.request({
      url: t,
      method: "PUT",
      data: e,
      ...r
    });
  }
  delete(t, e) {
    return this.request({
      url: t,
      method: "DELETE",
      ...e
    });
  }
  patch(t, e, r) {
    return this.request({
      url: t,
      method: "PATCH",
      data: e,
      ...r
    });
  }
}
class w {
  config;
  constructor(t = {}) {
    this.config = {
      baseURL: "",
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 3e4,
      ...t
    };
  }
  async request(t) {
    const { url: e, method: r = "GET", headers: o, params: n, data: i, ...a } = t, u = this.config.baseURL ? `${this.config.baseURL}${e}` : e, c = new URL(u);
    n && Object.entries(n).forEach(([l, p]) => {
      c.searchParams.append(l, p);
    });
    const f = {
      ...this.config.headers,
      ...o
    }, m = {
      url: c.toString(),
      method: r.toUpperCase(),
      header: f,
      data: i,
      timeout: this.config.timeout,
      ...a
    };
    return new Promise((l, p) => {
      uni.request({
        ...m,
        success: (h) => {
          h.statusCode === 200 ? l(h.data) : p(new Error(`HTTP error! status: ${h.statusCode}`));
        },
        fail: (h) => {
          p(new Error(`Request failed: ${h.errMsg}`));
        }
      });
    });
  }
  get(t, e) {
    return this.request({
      url: t,
      method: "GET",
      ...e
    });
  }
  post(t, e, r) {
    return this.request({
      url: t,
      method: "POST",
      data: e,
      ...r
    });
  }
  put(t, e, r) {
    return this.request({
      url: t,
      method: "PUT",
      data: e,
      ...r
    });
  }
  delete(t, e) {
    return this.request({
      url: t,
      method: "DELETE",
      ...e
    });
  }
  patch(t, e, r) {
    return this.request({
      url: t,
      method: "PATCH",
      data: e,
      ...r
    });
  }
}
class A {
  config;
  constructor(t = {}) {
    this.config = {
      baseURL: "",
      headers: {
        "Content-Type": "application/json"
      },
      timeout: 3e4,
      ...t
    };
  }
  async request(t) {
    return console.log("Mock HTTP request:", t), {};
  }
  get(t, e) {
    return this.request({
      url: t,
      method: "GET",
      ...e
    });
  }
  post(t, e, r) {
    return this.request({
      url: t,
      method: "POST",
      data: e,
      ...r
    });
  }
  put(t, e, r) {
    return this.request({
      url: t,
      method: "PUT",
      data: e,
      ...r
    });
  }
  delete(t, e) {
    return this.request({
      url: t,
      method: "DELETE",
      ...e
    });
  }
  patch(t, e, r) {
    return this.request({
      url: t,
      method: "PATCH",
      data: e,
      ...r
    });
  }
}
const E = {};
function S(s = {}) {
  switch (E?.VITE_HTTP_CLIENT) {
    case "axios":
      try {
        const e = require("./impl/axios").default;
        return new e(s);
      } catch {
        return console.warn("Axios is not installed, falling back to fetch implementation"), new q(s);
      }
    case "uniapp":
      return new w(s);
    case "fetch":
      return new q(s);
    case "mock":
      return new A(s);
    default:
      if (typeof window < "u" && window.fetch)
        return new q(s);
      if (typeof global < "u" && global.uni?.request)
        return new w(s);
      try {
        const e = require("./impl/axios").default;
        return new e(s);
      } catch {
        return console.warn("No HTTP client available, falling back to mock implementation"), new A(s);
      }
  }
}
const K = S(), O = {};
let y;
if (O?.VITE_HTTP_CLIENT === "axios")
  try {
    const s = require("axios");
    y = {
      async request(t, e) {
        const { method: r = "GET", headers: o = {}, params: n, body: i } = e;
        try {
          return (await s({
            url: t,
            method: r,
            headers: o,
            params: n,
            data: i
          })).data;
        } catch (a) {
          return console.error("Axios request failed:", a), null;
        }
      }
    };
  } catch {
    console.warn("Axios is not installed. Falling back to fetch implementation."), y = {
      async request(t, e) {
        const { method: r = "GET", headers: o = {}, params: n, body: i } = e, a = new URL(t);
        n && Object.entries(n).forEach(([u, c]) => {
          const f = typeof c == "string" ? c : String(c);
          a.searchParams.append(u, f);
        });
        try {
          const u = await fetch(a.toString(), {
            method: r,
            headers: o,
            body: i ? JSON.stringify(i) : void 0,
            credentials: "include"
          });
          return u.ok ? await u.json() : null;
        } catch (u) {
          return console.error("Request failed:", u), null;
        }
      }
    };
  }
else
  y = {
    async request(s, t) {
      const { method: e = "GET", headers: r = {}, params: o, body: n } = t, i = new URL(s);
      o && Object.entries(o).forEach(([a, u]) => {
        const c = typeof u == "string" ? u : String(u);
        i.searchParams.append(a, c);
      });
      try {
        const a = await fetch(i.toString(), {
          method: e,
          headers: r,
          body: n ? JSON.stringify(n) : void 0,
          credentials: "include"
        });
        return a.ok ? await a.json() : null;
      } catch (a) {
        return console.error("Request failed:", a), null;
      }
    }
  };
const Q = {
  request: y.request,
  async get(s, t, e) {
    return this.request(s, { method: "GET", params: t, ...e });
  },
  async post(s, t, e) {
    return this.request(s, { method: "POST", body: t, ...e });
  },
  async put(s, t, e) {
    return this.request(s, { method: "PUT", body: t, ...e });
  },
  async delete(s, t) {
    return this.request(s, { method: "DELETE", ...t });
  }
}, U = async (s) => d?.post("/exmay/manage/api/account/logout", s, {
  headers: {
    credentials: "include"
  }
}), j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  logoutApi: U
}, Symbol.toStringTag, { value: "Module" })), x = async (s) => d?.post("/seekflow/config/setting", s, {
  headers: {
    credentials: "include"
  }
}), C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  updateApi: x
}, Symbol.toStringTag, { value: "Module" })), L = async (s) => d?.post("/seekflow/config/setting", s, {
  headers: {
    credentials: "include"
  }
}), H = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  settingApi: L
}, Symbol.toStringTag, { value: "Module" })), R = async (s) => d?.post("/exmay/manage/api/wealth/credits/use?creditsCode=point", s, {
  headers: {
    credentials: "include"
  }
}), $ = async () => d?.get("/exmay/manage/api/wealth/credits?creditsCode=point", void 0, {
  headers: {
    credentials: "include"
  }
}), k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getPointApi: $,
  usePointApi: R
}, Symbol.toStringTag, { value: "Module" })), v = async (s) => d?.post("/seekflow/search/platform/listing", s, {
  headers: {
    credentials: "include"
  }
}), M = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  listingApi: v
}, Symbol.toStringTag, { value: "Module" })), G = async (s) => d?.post("/exmay/manage/api/extension/plugin/status", s, {
  headers: {
    credentials: "include"
  }
}), z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasPluginApi: G
}, Symbol.toStringTag, { value: "Module" })), D = async (s) => d?.post("/exmay/api/ums/member/islogin", s, {
  headers: {
    credentials: "include"
  }
}), I = async (s) => d?.get("/exmay/api/member/center/info", s, {
  headers: {
    credentials: "include"
  }
}), N = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isLoginApi: D,
  userInfoApi: I
}, Symbol.toStringTag, { value: "Module" })), W = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  account: j,
  client: C,
  config: H,
  credits: k,
  platform: M,
  plugin: z,
  user: N
}, Symbol.toStringTag, { value: "Module" })), F = {}, X = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auth: F
}, Symbol.toStringTag, { value: "Module" })), J = {}, Y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  admin: J
}, Symbol.toStringTag, { value: "Module" })), V = {}, Z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  common: V
}, Symbol.toStringTag, { value: "Module" }));
export {
  P as ApiClient,
  Y as admin,
  d as apiClient,
  X as auth,
  Z as common,
  S as createHttpClient,
  K as http,
  B as initApiClient,
  W as search,
  Q as simpleHttp,
  Q as simpleHttpInstance
};
//# sourceMappingURL=index.mjs.map
